// src/components/Hero.js /////
import '../styles/Hero.css';
import { FaWhatsapp, FaPhoneAlt } from 'react-icons/fa';
import Location from './Location';

const Hero = () => {
  const numeroWhatsapp = '5514998779843'; 
  const mensagemWhatsapp = 'Olá! Vim pelo site e preciso de um guincho. Pode me ajudar?';
  const linkWhatsapp = `https://wa.me/${numeroWhatsapp}?text=${encodeURIComponent(mensagemWhatsapp)}`;

  return (
    <section className="hero-container">
      <h1>TR VICTOR - GUINCHO E TRANSPORTES</h1>
      <p className="subtitle">Socorro 24 Horas para Carros e Motos em Bauru e Região</p>
      
      <div className="cta-buttons">
        <a 
          href={linkWhatsapp}
          target="_blank" 
          rel="noopener noreferrer" 
          className="btn btn-primary"
        >
          <FaWhatsapp /> Chamar no WhatsApp
        </a>
        <a href="tel:+5514998779843" className="btn btn-secondary">
          <FaPhoneAlt /> Ligar Agora
        </a>
        <Location />
      </div>
    </section>
  );
}

export default Hero;